// Actions
import { Action } from "@ms/uno-fluxcore/lib/local/actions/Action";
export class AppErrorAction extends Action {
    constructor(actionType, errorCode){
        super(actionType), this.errorCode = errorCode;
    }
}
